import { render, staticRenderFns } from "./ProcedureEvidenceView.vue?vue&type=template&id=7a1841ec&scoped=true"
import script from "./ProcedureEvidenceView.vue?vue&type=script&lang=js"
export * from "./ProcedureEvidenceView.vue?vue&type=script&lang=js"
import style0 from "./ProcedureEvidenceView.vue?vue&type=style&index=0&id=7a1841ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1841ec",
  null
  
)

export default component.exports